import SettingValue from './SettingValue';

export default SettingValue;
